import { Grid, InputAdornment, Paper, Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { Button, Input, InputAuto } from "../../controls";
import { Model, UseForm } from "../../hooks";
import { Form } from "../../layout";
import { AppContext } from "../../App";
import { API, actions, endpoints } from "../../api/api";
import { RmvEmptyProp, ToFormData } from "../../hooks/Method";
import { useTranslation } from "react-i18next";

const AddEditPlan = (props) => {
  const { t } = useTranslation();
  const { setAlert, setShowForm, updData, setPlans } = props;
  const { SubsPlanMdl } = Model();
  const [types, setTypes] = useState([]);
  const { branch, authUser } = useContext(AppContext);
  const {
    values,
    setValues,
    errors,
    setErrors,
    handleInpChg,
    resetFormControls,
  } = UseForm(SubsPlanMdl);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    updData && setValues((x) => ({ ...x, ...updData }));
    return () => {
      resetFormControls();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updData]);

  const validateForm = () => {
    let temp = {};
    temp.name = values.name !== "" ? "" : t("ValName");
    temp.subsTypeId = values.subsTypeId !== "" ? "" : t("ValSubsType");
    temp.duration = values.duration !== "" ? "" : t("ValDuration");
    temp.amt = values.amt !== "" ? "" : t("ValAmount");
    temp.freezeCount = values.freezeCount !== "" ? "" : t("ValFreeze");

    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  useEffect(() => {
    branch.id &&
      API(endpoints.SubsType + actions.GetAllByBranch).getById(
        branch.id,
        (res) =>
          res &&
          res.status === 200 &&
          setTypes([...res.result.map((j) => ({ ...j, label: j.name }))])
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branch]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoading(true);
      const onComplete = (res) => {
        setLoading(false);
        if (res && (res.status === 201 || res.status === 200)) {
          if (setPlans && res.result.id) {
            updData
              ? setPlans((x) => [
                  ...x.map((j) => (j.id === res.result.id ? res.result : j)),
                ])
              : setPlans((x) => [res.result, ...x]);
          }
          setAlert({
            isOpen: true,
            type: "success",
            title: t("Success"),
            subTitle: `${t("SubscriptionPlan")} ${
              updData ? t("Update") : t("Added")
            } ${t("Successfully")}.`,
          });
          setShowForm(false);
        } else if (res)
          setAlert({
            isOpen: true,
            type: "error",
            title: t("Error"),
            subTitle: res.msg,
          });
      };
      if (values.id === 0) {
        values.branchId = branch.id;
        values.orgId = branch.orgId;
        values.addedUserId = authUser.id;
        API(endpoints.SubsPlan + actions.Post).post(
          ToFormData(RmvEmptyProp(values)),
          onComplete
        );
      } else
        API(endpoints.SubsPlan + actions.Put).put(
          ToFormData(RmvEmptyProp(values)),
          onComplete
        );
    }
  };

  const handleClose = () => {
    setShowForm(false);
  };

  return (
    <>
      <Form onSubmit={handleSubmit} noValidate>
        <Paper
          className="p-15"
          sx={{ maxWidth: "750px", backgroundColor: "var(--aliceblue-color)" }}
        >
          <div className="mb-30 d-flex j-between a-center">
            <div>
              <Typography
                variant="span"
                className="mb-5 fw-4 gray-color tx-upp
                    border-left"
                sx={{ fontSize: { xs: "18px", md: "22px" } }}
              >
                {updData ? t("Edit") : t("Add")} {t("Plan")}
              </Typography>
            </div>

            <div className="d-flex g-10 flex-wrap">
              <Button variant="text" loading={loading} onClick={handleClose}>
                {t("Close")}
              </Button>
              <Button type="submit" loading={loading}>
                {updData ? t("SaveChanges") : t("Submit")}
              </Button>
            </div>
          </div>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Input
                label={t("Name")}
                name="name"
                value={values.name}
                error={errors.name}
                required={true}
                onChange={handleInpChg}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <InputAuto
                label={t("SubscritionType")}
                name="subsTypeId"
                required={true}
                value={values.subsTypeId}
                error={errors.subsTypeId}
                onChange={handleInpChg}
                options={types}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Input
                label={t("Amount")}
                name="amt"
                value={values.amt}
                error={errors.amt}
                required={true}
                onChange={handleInpChg}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Input
                label={t("Duration")}
                name="duration"
                value={values.duration}
                error={errors.duration}
                required={true}
                type="number"
                onChange={handleInpChg}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">days</InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Input
                label={t("FreeFreezeCount")}
                name="freezeCount"
                value={values.freezeCount}
                error={errors.freezeCount}
                required={true}
                type="number"
                onChange={handleInpChg}
              />
            </Grid>
          </Grid>
        </Paper>
      </Form>
    </>
  );
};

export default AddEditPlan;
